import { useSelector } from "react-redux";
import VisitingCard from "./VisitingCard";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Typography
} from "@mui/material";

const MyVisitingCard = () => {
  const visitingCardData = useSelector(
    (state) => state?.CardArray?.visitingCard
  );

  const cardDetails = {
    ...visitingCardData?.professionalCardData?.cardDetails,
    cardName: "Professional",
    token: visitingCardData?.accessToken,
    firstName: visitingCardData?.professionalCardData?.cardDetails?.first_name,
    lastName: visitingCardData?.professionalCardData?.cardDetails?.last_name,
    profile_pic:
      visitingCardData?.professionalCardData?.cardDetails?.profile_pic,
    designation:
      visitingCardData?.professionalCardData?.cardDetails?.designation,
    defaultPhone: visitingCardData?.personalCardData?.cardDetails?.phone_no,
    defaultEmail: visitingCardData?.personalCardData?.cardDetails?.email,
  };

  const cardQrStyles = {
    ...visitingCardData?.professionalCardData?.qrStyles,
    CardName: "Professional",
    eyeBall: "",
    eyeBallcolor: "",
    eyeFrame: "",
    eyeFrameColor: "",
    qrPattern: "",
    qrPatterncolor: "#121212",
    border: "",
    bordercolor: "",
    addbg: "",
    addbgcolor: "#ede8e8",
    logo: "",
  };

 const cardContacts = visitingCardData?.professionalCardData?.contactDetails;

  return (
    <Box>
      <VisitingCard
        cardDetails={cardDetails}
        cardQrstyles={cardQrStyles}
        cardContacts={cardContacts}
        activeProfile={"professional_profile"}
        isOwner={true}
      />
    </Box>
  );
};

export default MyVisitingCard;
